"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MOTION = {
  default: "160ms ease",
  "@media (prefers-reduced-motion: reduce)": "0s"
};
const styles = exports.styles = {
  group: {
    marginBottom: "xc8tqf8",
    $$css: true
  },
  heading: {
    margin: "x1xu1054",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontFamily: "xzjhs3a",
    fontSize: "xboafo0",
    fontWeight: "x1s688f",
    letterSpacing: "x1dgsrnt",
    textTransform: "xtvhhri",
    color: "xldsce3",
    $$css: true
  },
  list: {
    listStyle: "xe8uvvx",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  item: {
    borderTopWidth: "x178xt8z x1g31smg",
    borderTopStyle: "x13fuv20",
    borderTopColor: "x1a6tffd",
    $$css: true
  },
  row: {
    display: "xrvj5dj",
    gridTemplateColumns: "xx9t13c",
    alignItems: "x6s0dn4",
    columnGap: "xvmnrrq",
    minHeight: "x13gjtz1",
    paddingTop: "xumxmzd",
    paddingBottom: "xota9p6",
    paddingLeft: "xf00w7v",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    paddingRight: "x1d60ukw",
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    color: "x10kmngs",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    backgroundColor: "xjbqb8w x14sfa1n xeq8lma",
    outlineWidth: "x1k57tk5 x784prv",
    outlineStyle: "xaatb59",
    outlineColor: "x1yrgfsk",
    outlineOffset: "x2ssjo2",
    transitionProperty: "x15406qy",
    transitionDuration: "xsgsqy0 x12w9bfk",
    $$css: true
  },
  glyph: {
    display: "x3nfvp2",
    color: "xcdm7ny",
    $$css: true
  },
  text: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x1iah58g",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  label: {
    fontSize: "x1gqo1bu",
    fontWeight: "x1s688f",
    lineHeight: "xwn7fz2",
    $$css: true
  },
  description: {
    fontSize: "xyr29y3",
    lineHeight: "x1xfvgam",
    color: "xcdm7ny",
    $$css: true
  },
  rowButton: {
    width: "xh8yej3",
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    fontFamily: "x1wl88yq",
    fontSize: "x1qlqyl8",
    textAlign: "xdpxx8g",
    cursor: "x1ypdohk",
    $$css: true
  }
};